import { useState } from 'react';
import { useAdminClinicList } from 'infrastructure/hooks/clinic/use-admin-clinic-list';

export const useLazyClinicChildren = (parentGuid?: string, enabled = false) => {
  const [enabledFetch, setEnabledFetch] = useState(enabled);

  const result = useAdminClinicList({
    meta: {
      parentClinicGuid: parentGuid,
      items: 9999,
    },
    enabled: enabledFetch,
  });

  const trigger = () => setEnabledFetch(true);

  return { ...result, trigger };
};
